import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import FullServiceManagement from "./sections/FullServiceManagement";
import TheManagementProcess from "./sections/TheManagementProcess";
import InvestKcFooter from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <FullServiceManagement />
      <TheManagementProcess />
      <InvestKcFooter />
    </div>;
}